/* eslint-disable hubspot-dev/no-private-classes */

/**
* @deprecated Use merchandise-lib/static-1.251/constants/QuantityName.ts instead
*/
export const QuantityPacks = {
  DEFAULT_QUANTITY_PACK: 'default-quantity-pack',
  ADDITIONAL_MARKETING_CONTACTS: 'additional-marketing-contacts',
  ADDITIONAL_LEGACY_CONTACTS: 'additional-legacy-contacts',
  ADDITIONAL_SALES_SEATS: 'additional-sales-seats',
  ADDITIONAL_SERVICE_SEATS: 'additional-service-seats',
  ADDITIONAL_COMMERCE_SEATS: 'additional-commerce-seats'
};
export default QuantityPacks;